export const communityRoutePaths = {
  realEstateList: {
    path: 'community/real-estate',
    fullPath: '/community/real-estate',
  },
  realEstateWrite: {
    path: 'community/real-estate/write',
    fullPath: '/community/real-estate/write',
  },
  realEstateDetail: {
    path: 'community/real-estate/:id',
    fullPath: (id: string) => `/community/real-estate/${id}`,
  },
};
